import axios, { isAxiosError } from 'axios';
import { resolveApiUrl } from '@/config';
const http = axios.create({
    timeout: 20000,
    withCredentials: true,
});
function toRequestError(err, fallback = '请求失败') {
    if (isAxiosError(err)) {
        if (err.code === 'ECONNABORTED') {
            return new Error('网络请求超时，请检查网络后重试');
        }
        if (!err.response) {
            const detail = [err.code, err.message].filter(Boolean).join(' ');
            return new Error(detail
                ? `无法连接服务器（${detail}）`
                : '无法连接服务器，请确认网络正常或联系管理员');
        }
        // OOS 常用 HTTP 404 返回业务错误（如未获取到 HEAD/TOKEN），优先读 MSG
        const body = err.response.data;
        const bizMsg = body?.HEAD?.MSG;
        if (bizMsg)
            return new Error(bizMsg);
        const status = err.response.status;
        if (status >= 500)
            return new Error(`服务器异常（${status}），请稍后重试`);
        if (status === 404)
            return new Error('接口不存在（404），请检查部署与 Nginx 反代配置');
    }
    return err instanceof Error ? err : new Error(fallback);
}
let sessionToken = '';
export function setSessionToken(token) {
    sessionToken = token || '';
}
export function getSessionToken() {
    return sessionToken;
}
async function post(path, body = {}) {
    try {
        const { data } = await http.post(resolveApiUrl(path), {
            HEAD: { TOKEN: '' },
            BODY: body,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Cs-Token': sessionToken,
            },
        });
        const head = data?.HEAD;
        if (!head || head.CODE !== '000') {
            throw new Error(head?.MSG || '请求失败');
        }
        return (data.BODY ?? {});
    }
    catch (err) {
        throw toRequestError(err);
    }
}
export const csInit = (body) => post('/kf/h5/init', body);
export const csCredential = (body) => post('/kf/h5/credential', body);
export const csSessionStart = (body) => post('/kf/h5/session/start', body);
export const csSessionCurrent = (body) => post('/kf/h5/session/current', body);
export const csSessionList = (body) => post('/kf/h5/session/list', body);
export const csMessageList = (body) => post('/kf/h5/message/list', body);
export const csSessionClose = (body) => post('/kf/h5/session/close', body);
export const csVisitorUpdate = (body) => post('/kf/h5/visitor/update', body);
